export const FIELD_DEFS = {
  lugar: { header: "lugar", label_es: "Lugar", label_en: "Place", type: "text" },
  precio: { header: "precio", label_es: "Precio", label_en: "Price", type: "number" },
  qty: { header: "qty", label_es: "Cantidad", label_en: "Quantity", type: "number" },
  sitio_inicial: { header: "sitio_inicial", label_es: "Sitio Inicial", label_en: "Origin Site", type: "text", maxlen: 8 },
  sitio_final: { header: "sitio_final", label_es: "Sitio Final", label_en: "Destination Site", type: "text", maxlen: 8 },
};

export const FORMAT_PRESETS = {
  estandar: { fields: [], label_es: "Estándar", label_en: "Standard" },
  ventas: { fields: ["lugar", "precio", "qty"], label_es: "Ventas", label_en: "Sales" },
  transferencia: { fields: ["sitio_inicial", "sitio_final", "qty"], label_es: "Transferencia", label_en: "Transfer" },
  personalizado: { fields: [], label_es: "Personalizado", label_en: "Custom" },
};

export const CUSTOMIZABLE_FIELD_KEYS = Object.keys(FIELD_DEFS);
